import { skills } from '../data/skills';
import './Skills.css';

const padIndex = (i: number) => String(i + 1).padStart(2, '0');

export function Skills() {
  return (
    <section className="section" id="stack" aria-labelledby="stack-heading">
      <div className="section-head" data-reveal>
        <span className="section-index">06</span>
        <h2 id="stack-heading">
          Core stack <span className="section-count">/ {skills.length}</span>
        </h2>
        <p className="section-sub">The tools I reach for first.</p>
      </div>

      <ul className="skill-grid" aria-label="Skills">
        {skills.map((skill, i) => (
          <li
            key={skill}
            className="skill-cell"
            data-reveal
            style={{ ['--i' as string]: i } as React.CSSProperties}
          >
            <span className="skill-num">{padIndex(i)}</span>
            <span className="skill-name">{skill}</span>
            <span className="skill-arrow" aria-hidden>↗</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
